module.exports = __webpack_public_path__ + "static/media/ANL.1f90821a.svg";